export default "__VITE_ASSET__CQn5CPRY__"